export class CloudPrincipalInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "aws",
            "baseName": "aws",
            "type": "AwsPrincipalInput",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "GcpPrincipalInput",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CloudPrincipalInput.attributeTypeMap;
    }
    constructor() {
    }
}
